// 마스킹 컬럼 처리 함수
export const maskSecretValue = (value: string, type: string) => {
  if (!value) return '';
  if (type === 'tel') {
    const removedHyphen = value.replaceAll('-', ''); // 하이픈을 포함해서 DB에 저장된 데이터와 하이픈을 포함하지 않은 데이터의 타입 통일을 위해 하이픈 삭제
    const newValue = autoHyphen(removedHyphen);
    const [first, second, third] = newValue.split('-');
    if (!second) {
      return `${newValue.substring(0, 1)}***${newValue.substring(4)}`;
    }
    const masking = second?.replace(/[0-9]/g, '*');
    return `${first}-${masking}-${third}`;
  }
  if (type === 'birth') {
    return maskBirthValue(value);
  }
  // 기타 (예:이름) 마스킹: 첫 글자 + * + 세 번째 글자부터 (예: 김*철)
  return `${value.substring(0, 1)}*${value.substring(2)}`;
};

const autoHyphen = (target: string) => {
  if (target.slice(0, 2) === '02') {
    return target.replace(/[^0-9]/g, '').replace(/^(\d{2})(\d{3,4})(\d{4})$/, `$1-$2-$3`);
  }
  const value = target.replace(/[^0-9]/g, '').replace(/^(\d{2,3})(\d{3,4})(\d{4})$/, `$1-$2-$3`);
  return value;
};

// 생년월일 마스킹 함수
export const maskBirthValue = (value: string) => {
  if (!value || value.length !== 10) return '';
  return `${value.substring(0, 4)}-**-${value.substring(8)}`;
};
